import { combine, withCallbacks, withStateHandlers } from 'react-hooks-combine'

import BinaryBetModalComponent from './component'

export const BinaryBetModal = combine(
  withStateHandlers(
    {
      opened: false,
      event: null,
    },
    {
      open: ({ args: [opened] }) => ({ opened }),
      setEventData: ({ args: [event] }) => ({ event }),
    }
  ),

  withCallbacks(
    {
      onTrigger:
        ({ open, setEventData }) =>
        (event) => {
          setEventData(event)
          open(true)
        },

      onInWinnableProxy:
        (_, { onInwinableBet }) =>
        () => {
          onInwinableBet()
        },

      onBetProxy:
        ({ open, event }, { onResolveBet }) =>
        (betDetails) => {
          onResolveBet(betDetails, event)
          open(false)
        },

      onRequestClose:
        ({ open }) =>
        () => {
          open(false)
        },
    },
    ['onBet']
  )
)(BinaryBetModalComponent)
